import { render, staticRenderFns } from "./Cdg.vue?vue&type=template&id=24006a12&"
import script from "./Cdg.vue?vue&type=script&lang=js&"
export * from "./Cdg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports